export default __webpack_public_path__ + "static/media/lion_wating.e986c461.png";